/** A non-null object whose keys can be read: what a thrown body or wire payload is narrowed from. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null;
